import React, { useEffect } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Link as RouterLink } from "react-router-dom";

import { getInitials } from "helpers";
import { connect } from "react-redux";
import * as actions from "redux/actions/watchStockActions";
import * as quoteActions from "redux/actions/quoteActions";
import StockAvatar from "components/StockAvatar";
import AlertModal from '../AlertModal';
import { Translate } from "react-redux-i18n";

import { Trash, Star} from "theme/icon";


// const useStyles = {
//   root: {},
//   content: {
//     padding: 0,
//   },
//   inner: {
//     minWidth: 1050,
//   },
//   nameContainer: {
//     display: "flex",
//     alignItems: "center",
//   },
//   avatar: {
//     marginRight: theme.spacing(2),
//   },
//   actions: {
//     justifyContent: "flex-end",
//   },
//   avatar: {
//     marginRight: '7px',
//     height: 30,
//     width: 30,
//     flexDirection: 'row',
//     position: "absolute",
//     borderRadius: "5px"
//   },
// };




const Table_ = (props) => {
  const { className, history, ...rest } = props;

  // const [selectedList, setSelectedList] = useState([]);
  // const [rowsPerPage, setRowsPerPage] = useState(25);
  // const [page, setPage] = useState(0);
  /*
    const handleSelectAll = (event) => {
      const { list } = props;
  
      let selectedList;
  
      if (event.target.checked) {
        selectedList = list.map((item) => item.id);
      } else {
        selectedList = [];
      }
      setSelectedList(selectedList);
    };
  
    const handleSelectOne = (event, id) => {
      const selectedIndex = selectedList.indexOf(id);
      let newSelectedList = [];
  
      if (selectedIndex === -1) {
        newSelectedList = newSelectedList.concat(selectedList, id);
      } else if (selectedIndex === 0) {
        newSelectedList = newSelectedList.concat(selectedList.slice(1));
      } else if (selectedIndex === selectedList.length - 1) {
        newSelectedList = newSelectedList.concat(selectedList.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelectedList = newSelectedList.concat(
          selectedList.slice(0, selectedIndex),
          selectedList.slice(selectedIndex + 1)
        );
      }
  
      setSelectedList(newSelectedList);
    };
  
    const handlePageChange = (event, page) => {
      setPage(page);
    };
  
    const handleRowsPerPageChange = (event) => {
      setRowsPerPage(event.target.value);
    };
  */

  const onClickDelete = (item) => {
    props.removeItem(props.token, { stock_list_id: item.id, id: props.user_id });
  };

  useEffect(() => {
    if (!props.user_id || !props.list?.length) {
      return;
    }
    const symbols = [...new Set(props.list.map((item) => item.symbol).filter(Boolean))];
    if (symbols.length) {
      props.loadStockQuotes(symbols, props.user_id, props.token);
    }
  }, [props.user_id, props.token, props.list]);

  const formatLastPrice = (item) => {
    const liveQuote = props.stock?.[item.symbol];
    const live = Number(liveQuote?.c);
    const fromLive = live > 0 ? live : Number(liveQuote?.pc);
    const fromItem = Number(item?.ask ?? item?.bid);
    const value = fromLive > 0 ? fromLive : fromItem;
    if (!Number.isFinite(value) || value <= 0) {
      return '—';
    }
    return value.toFixed(2);
  };

  return (
    <div className="">
          <table className="table table-hover watchlist-table">
            <thead>
              <tr>
                <th>Symbol</th>
                <th>Name</th>
                <th>Exchange</th>
                <th className="text-end">
                  <Translate value="alerts_last_price" />
                </th>
                <th className="text-end">Change</th>
                <th className="text-end">Change%</th>
                <th className="text-end">Volume</th>
                <th className="text-center">Act</th>
              </tr>
            </thead>
            <tbody className="">
              {props.list.map((item) => (
                <tr
                  key={item.id}
                >
                  {/* {console.log(item)} */}
                  <td>
                    <div className="symbol-cell">
                      <StockAvatar item={item} symbol={item.symbol} className="avatar-sm" />
                      <div className="symbol-meta">
                        <RouterLink
                          to={"/stock/" + item.symbol}
                          className="symbol-link"
                        >
                          {item.symbol.toUpperCase()}
                        </RouterLink>
                        {item.dividend === '1' && (
                          <Star className="symbol-star" />
                        )}
                      </div>
                    </div>
                  </td>
                  <td>{item.name}</td>
                  <td>{item.exchange}</td>
                  <td align="right">
                    {formatLastPrice(item)}
                  </td>
                  <td
                    align="right"
                    className={Number(item.change) >= 0 ? "text-success" : "text-danger"}
                  >
                    {item.change}
                  </td>
                  <td
                    align="right"
                    className={Number(item.change_p) >= 0 ? "text-success" : "text-danger"}
                  >
                    {item.change_p}
                  </td>
                  <td align="right">
                    {item.volume}
                  </td>
                  <td className="text-center alerts-actions-cell">
                    <AlertModal key={`alert-${item.id}`} item={item} />
                    <button
                      type="button"
                      className="watchlist-action-icon"
                      onClick={() => { onClickDelete(item); }}
                    >
                      <Trash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
  );
};

Table_.propTypes = {
  className: PropTypes.string,
  list: PropTypes.array.isRequired,
  history: PropTypes.object
};

function mapStateToProps(reducer) {
  //console.log(reducer);
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.token,

    list: reducer.watchStock.list,
    stock: reducer.event.stock,

    auth: reducer.session.auth,
  };
}

const mapDispatchToProps = dispatch => ({
  removeItem: (token, params) =>
    dispatch(actions.removeItem({ token, params })),
  loadStockQuotes: (symbols, user_id, token) =>
    dispatch(quoteActions.loadStockQuotes({ symbols, user_id, token })),
});
export default connect(mapStateToProps, mapDispatchToProps)(Table_);
/**
 *       <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={list.length}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>
 * slice(0, rowsPerPage)
 * <TableCell>
                      {item.year}
                    </TableCell>
                    <TableCell>
                      {item.color}
                    </TableCell>
                     <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedList.length === list.length}
                      color="primary"
                      indeterminate={
                        selectedList.length > 0 &&
                        selectedList.length < list.length
                      }
                      onChange={handleSelectAll}
                    />
                  </TableCell>

                   <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedList.indexOf(item.id) !== -1}
                        color="primary"
                        onChange={(event) => handleSelectOne(event, item.id)}
                        value="true"
                      />
                    </TableCell>
 */
